import { defineMessages } from 'dibs-react-intl';

// components
import { SbSharedRefineMenuFilterMetal } from './SbSharedRefineMenuFilterMetal.jsx';
import { SbSharedRefineMenuFilterStyle } from './SbSharedRefineMenuFilterStyle.jsx';
import { SbSharedRefineMenuFilterArtSubject } from './SbSharedRefineMenuFilterArtSubject.jsx';
import { SbSharedRefineMenuFilterColor } from './SbSharedRefineMenuFilterColor.jsx';
import { SbSharedRefineMenuFilterStone } from './SbSharedRefineMenuFilterStone.jsx';
import { SbSharedRefineMenuFilterPeriod } from './SbSharedRefineMenuFilterPeriod.jsx';
import { SbSharedRefineMenuFilterRingSize } from './SbSharedRefineMenuFilterRingSize.tsx';
import { SbSharedRefineMenuFilterOrigin } from './SbSharedRefineMenuFilterOrigin.jsx';
import { SbSharedRefineMenuFilterCreator } from './SbSharedRefineMenuFilterCreator.jsx';
import { SbSharedRefineMenuFilterMaterial } from './SbSharedRefineMenuFilterMaterial.jsx';
import { SbSharedRefineMenuFilterItemType } from './SbSharedRefineMenuFilterItemType.jsx';
import { SbSharedRefineMenuFilterJewelryType } from './SbSharedRefineMenuFilterJewelryType.jsx';
import { SbSharedRefineMenuFilterAvailability } from './SbSharedRefineMenuFilterAvailability.jsx';
import { SbSharedRefineMenuFilterMatchingSets } from './SbSharedRefineMenuFilterMatchingSets.jsx';
import { SbSharedRefineMenuFilterGender } from './SbSharedRefineMenuFilterGender.jsx';
import { SbSharedRefineMenuFilterFraming } from './SbSharedRefineMenuFilterFraming.tsx';
import { SbSharedRefineMenuFilterArtOrientation } from './SbSharedRefineMenuFilterArtOrientation.tsx';
import { SbSharedRefineMenuFilterFramingOld } from './SbSharedRefineMenuFilterFramingOld.tsx';
import { SbSharedRefineMenuFilterMovement } from './SbSharedRefineMenuFilterMovement.jsx';

const titleOverrides = defineMessages({
    framing: {
        id: 'sb.SharedRefineMenuFilterFramingOptions.title',
        defaultMessage: 'Framing',
    },
});

/* eslint-disable camelcase */

export const sbSharedRefineMenuFiltersMap = {
    color: {
        component: SbSharedRefineMenuFilterColor,
    },
    creator: {
        component: SbSharedRefineMenuFilterCreator,
    },
    item_type: {
        component: SbSharedRefineMenuFilterItemType,
    },
    'jewelry-type': {
        component: SbSharedRefineMenuFilterJewelryType,
    },
    lead_time_bucket: {
        component: SbSharedRefineMenuFilterAvailability,
    },
    matchingSets: {
        component: SbSharedRefineMenuFilterMatchingSets,
    },
    material: {
        component: SbSharedRefineMenuFilterMaterial,
    },
    metal: {
        component: SbSharedRefineMenuFilterMetal,
    },
    origin: {
        component: SbSharedRefineMenuFilterOrigin,
    },
    period: {
        component: SbSharedRefineMenuFilterPeriod,
    },
    'ring-size': {
        component: SbSharedRefineMenuFilterRingSize,
    },
    stone: {
        component: SbSharedRefineMenuFilterStone,
    },
    style: {
        component: SbSharedRefineMenuFilterStyle,
    },
    'subject-matter': {
        component: SbSharedRefineMenuFilterArtSubject,
    },
    gender: {
        component: SbSharedRefineMenuFilterGender,
    },
    frameIncluded: {
        component: SbSharedRefineMenuFilterFramingOld,
        title: titleOverrides.framing,
        isBatchAppliedFilter: true,
    },
    framing: {
        component: SbSharedRefineMenuFilterFraming,
        title: titleOverrides.framing,
        isBatchAppliedFilter: true,
    },
    framingOptionAvailable: {
        component: null,
        isBatchAppliedFilter: true,
    },
    'art-shape': {
        component: SbSharedRefineMenuFilterArtOrientation,
    },
    movement: {
        component: SbSharedRefineMenuFilterMovement,
    },

    /**
     * Pass in empty objects to indicate that the filter can appear in applied filters, but it won't be
     * shown in the refine menu filter list.
     */
    refineSearch: {},
    technique: {},
    'shipping-free': {
        isBatchAppliedFilter: true,
    },
    'max-white-glove-price': {},
    'white-glove-shipping': {
        isBatchAppliedFilter: true,
    },
};
